export const apiConfigs = {
   baseURL : "https://cheapship.ca/v1/",
   //  baseURL : "http://127.0.0.1:8000/v1/",
};
